<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>

  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet">

  <title>NokNok Standard Terms and Conditions</title>

  <style>
    :root {
        --bg: #f7f8fb;
        --surface: #ffffff;
        --text: #1b1f2a;
        --muted: #5b6478;
        --primary: #2b59ff;
        --heading-bg: #eef2ff;
        --border: rgba(20, 30, 55, 0.12);
        --shadow: 0 10px 30px rgba(20, 30, 55, 0.08);
        --radius: 18px;
        --radius-sm: 12px;
    }

    * {
        box-sizing: border-box;
    }

    body {
        margin: 0;
       font-family: "Poppins", sans-serif;

        background: var(--bg);
        line-height: 1.7;
    }

    /* ====== Header / Nav ====== */
    .site-header {
        /*position: sticky; */
        top: 0;
        z-index: 50;
        background: #020371;
        backdrop-filter: blur(12px);
        border-bottom: 1px solid var(--border);
    }

    .site-header .header-inner {
        max-width: 1100px;
        margin: 0 auto;
        padding: 14px 18px;
        display: grid;
        place-items: center;
        gap: 8px;
    }

    .brand {
        display: grid;
        place-items: center;
        margin-bottom: 10px;
        text-align: center;
    }

    .brand img {
        width: 90px;
        height: 90px;
        object-fit: contain;

    }

    .brand h1 {
        margin: 0;
        font-size: 26px;
        font-weight: 700;
        letter-spacing: 0.2px;
        line-height: 1.2;
        color:  #fff;
    }

    .brand p {
        margin: 0;
        font-size: 13px;
        color: var(--muted);
        line-height: 1.2;
    }

    /* ====== Page Layout ====== */
    .page {
        max-width: 1100px;
        margin: 0 auto;
        padding: 26px 18px 60px;
        display: grid;
        gap: 18px;
    }

    /* Content Card */
    .content {
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: var(--radius);
        box-shadow: var(--shadow);
        padding: 26px 22px;
    }

    /* Main title (your original H1) */
    .content > h1 {
        margin: 0 0 14px;
        font-size: clamp(22px, 2.2vw, 30px);
        font-weight: 900;
        letter-spacing: -0.2px;
    }

    /* Rounded heading blocks */
    .content h2 {
        margin: 26px 0 12px;
        padding: 4px 14px;
        font-size: clamp(16px, 1.6vw, 18px);
        font-weight: 600;
        background-color: #020371;
        border: 1px solid rgba(43, 89, 255, 0.16);
        border-radius: 999px;
        display:  inline-block;
        color: #ffffff  ;
    }


    .content p {
        margin: 0 0 14px;
        color: #2a3142;
        font-size: 15.5px;
    }

    .content a {
        color: var(--primary);
        text-decoration: none;
        font-weight: 700;
    }

    .content a:hover {
        text-decoration: underline;
    }

    .content ol,
    .content ul {
        margin: 0 0 16px;
        padding-left: 22px;
    }

    .content li {
        margin: 10px 0;
        color: #2a3142;
    }

    /* Make long text readable */
    .content {
        word-break: break-word;
        overflow-wrap: anywhere;
    }

    /* ====== Footer ====== */
    .site-footer {
        margin-top: 40px;
        border-top: 1px solid var(--border);
        background: #020371;
        color: rgba(255, 255, 255, 0.85);
    }

    .site-footer .footer-inner {
        max-width: 1100px;
        margin: 0 auto;
        padding: 34px 18px;
        display: grid;
        gap: 26px;
        grid-template-columns: 1.2fr 1fr 1fr 1fr;
    }

    .footer-brand {
        display: grid;
        gap: 12px;
    }

    .footer-brand .footer-logo {
        display: flex;
        align-items: center;

    }

    .footer-logo img {
        width: 128px;
        height: 90px;
    }

    .footer-brand strong {
        font-size: 16px;
        color: #fff;
        letter-spacing: 0.2px;
    }

    .footer-brand p {
        margin: 0;
        color: rgba(255, 255, 255, 0.7);
        font-size: 13px;
        line-height: 1.6;
    }


    .store-icons a {
        display: inline-flex;
        align-items: center;
        justify-content: center;


    }
    .store-icons img {
        width: 120px;
        height: 120px;
    }

    .store-icons a:hover {
        border-color: rgba(255, 255, 255, 0.35);
    }

    .footer-col h3 {
        margin: 0 0 12px;
        font-size: 14px;
        color: #fff;
        letter-spacing: 0.2px;
    }

    .footer-links {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        gap: 10px;
    }

    .footer-links a {
        color: rgba(255, 255, 255, 0.72);
        text-decoration: none;
        font-size: 13.5px;
    }

    .footer-links a:hover {
        color: #fff;
    }

    .social {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    .social a {
        width: 42px;
        height: 42px;
        border-radius: 14px;
        display: grid;
        place-items: center;
        border: 1px solid rgba(255, 255, 255, 0.18);
        color: #fff;
        text-decoration: none;
        font-weight: 900;
    }

    .social a:hover {
        border-color: rgba(255, 255, 255, 0.35);
    }

    .footer-bottom {
        border-top: 1px solid rgba(255, 255, 255, 0.12);
        padding: 14px 18px;
        text-align: center;
        font-size: 12.5px;
        color: rgba(255, 255, 255, 0.6);
    }

    /* ====== Responsive ====== */
    @media (max-width: 900px) {
        .site-footer .footer-inner {
            grid-template-columns: 1fr 1fr;
        }
    }

    @media (max-width: 560px) {
        .content {
            padding: 18px 16px;
        }

        .content h2 {
            border-radius: 16px;
            padding: 10px 12px;
        }

        .site-footer .footer-inner {
            grid-template-columns: 1fr;
        }

        .brand img {
            width: 52px;
            height: 52px;
        }
    }
  </style>
</head>

<body>

<!-- Header / Navigation -->
<header class="site-header">
  <div class="header-inner">
    <div class="brand">
      <!-- Replace this with your real logo -->
      <img src="assets/images/terms-and-conditions/logo2.png" alt="NokNok Logo" />
      <h1>Standard Terms and Conditions</h1>

    </div>
  </div>
</header>

<!-- Page Content -->
<main class="page">
  <section class="content">


    <p>These standard terms and conditions ("Terms") apply to your access to and use of the NokNok application (the "Application"). This service is provided by NokNok SAL ('NokNok").</p>

    <p>These Terms form a binding contract between you and NokNok, which commences on the date of the signature of the Terms by the parties.</p>

    <p>The Merchant Commercial Offer ("MCO"), the Merchant Information Form ("MIF") and Branch Information Form ("BIF") as hard copies Schedules 1, 2 & 3 respectively will be read and construed as an integral part of the Terms.</p>

    <p>If you have questions about these Terms, our Application, or our services, please contact us via your dedicated Commercial Executive and/or by email via <a href="mailto:info@noknok-lebanon.co">info@noknok-lebanon.co</a>.</p>

    <h2>1. The Application</h2>
    <p>Through the Application, NokNok will provide you with a real-time direct ordering service that enables customers ("Customers") to place orders with you on the Application for delivery in Lebanon in your specific delivery area as provided for in the MIF.</p>

    <h2>2. Onboarding Process</h2>
    <p>During your onboarding, you must provide us with an accurate description of menu items or products (for retailers other than restaurants) to be offered in the Application, images thereof, any relevant allergen advice, prices, discounts, your branch locations, working hours, contact numbers, promotional offers, and any other data requested by NokNok in the MIF, BIF, or otherwise, as well with any amendments and additions to the foregoing in accordance with these Terms ("Merchant Information").</p>

    <h2>3. What NokNok Will Do</h2>
    <p>During your onboarding, NokNok will:</p>
    <ol>
      <li>Upload your Merchant Information to the Application. For this purpose, you hereby authorize NokNok to publish your Merchant Information on the Application and grant NokNok a non-exclusive, royalty-free license to use and display your Merchant Information and modify the format and presentation thereof to ensure compatibility with the Application's technical requirements and user interface;</li>
      <li>Provide you with the tools and access (through a designated link) to the ordering platform; and</li>
      <li>Train your personnel to manage and operate the merchant portal and dashboard.</li>
    </ol>

    <p>Once onboarded, as mentioned above, Customers located within the delivery zones specified in the MIF will be able to place orders with you via the Application. NokNok will notify you via your Merchant APP and Portal of such order and NokNok will assign a driver to pick-up the order and to deliver it to the Customer. NokNok will deliver the order to such Customers either using its own fleet or through service providers.</p>

    <p>NokNok will collect, on your behalf, payments done either via cash or electronically and you hereby authorize NokNok, its employees, and service providers to do so.</p>

    <h2>4. Your Obligations</h2>
    <p>You should notify NokNok of any amendments and additions to your Merchant Information at least 5 (five) business days before you implement them and you agree that they will take effect on the Application only at the expiry of the 5 (five) business days period mentioned in this section.</p>

    <p>You undertake to remain fully operational, active, and fulfill orders on the Application in all your branches throughout your working hours as stipulated in the BIF and you agree to hold NokNok harmless and indemnify it against any liability or damage it could suffer from any breach to the foregoing.</p>

    <p>Upon receipt of an order, you will be responsible for the confirmation or rejection of the order and the preparation of the confirmed order and its packing. NokNok will only pick up and deliver the order to the Customer as provided for in these Terms. You must not reject an order through the Application unless you are unable to fulfill the relevant order.</p>

    <p>You must ensure that all relevant menu items, or products (for retailers other than restaurants), featured on your page on the Application are available to be ordered by a Customer during your working hours and accept and reject an order as appropriate. If an item is out of stock, you should indicate it on the Application by marking that the relevant item is out of stock. If a Customer has ordered an item and it was later revealed that such item is out of stock, you should inform the Customer of this and provide the latter with the option to either replace if out of stock item with another item or cancel the order with refund which you will fully bear (full value paid by the customer for the cancelled item/order).</p>

    <p>You must ensure that all orders are prepared using all due skill, care and diligence and in line with applicable laws and regulations and the best practice of the industry, and ensure that orders are packaged in a way that avoids tampering, minimizes spillages, and maintains the order at an appropriate condition and temperature.</p>

    <p>You must prepare orders promptly, accurately, and in a manner allowing the delivery of the order to the Customer within the average preparation time agreed upon and mentioned in the BIF.</p>

    <p>You must ensure that all menu items correspond with the description on the Application (including but not limited to indications related to their macronutrients (if any) and indications that particular menu items are gluten free, nut free, or suitable for vegetarians and/or vegans) and have been properly cooked or prepared and are otherwise safe, fit for transportation and consumption.</p>

    <p>You must ensure that you take account of any notes provided by the Customer with its order including, but not limited to, information relating to Customer allergies and bear all responsibilities in case of non-compliance with the Customer notes and ensuing complications due to allergies.</p>

    <p>You must maintain the security and confidentiality of any access credentials you possess and you are the sole party responsible for the actions of any person using your access credentials.</p>

    <p>You must comply at all times with all applicable laws and licensing, registration, and approval requirements at all times, and any and all NokNok policies made available to you from time to time.</p>

    <p>You hereby warrant that you have not and will not do anything that breaches any applicable code and/or sanction relating to the prevention or prohibition of bribery, money laundering, terrorist financing, and similar activities and you must notify NokNok immediately if you become aware of any breach of this section.</p>

    <p>You must cooperate with NokNok and provide, in a timely manner, such assistance and information as NokNok may require particularly in the event NokNok is handling a Customer complaint.</p>

    <p>In the event NokNok provides you with a handset, SIM card, and/or tablet/device, you will be fully responsible for such equipment and you shall return such equipment to NokNok upon the termination of these Terms in the condition in which they were received, taking into account reasonable tear and wear, failing which you will settle to NokNok the price of the replacement thereof.</p>

    <h2>5. Fee</h2>
    <p>In consideration for our services, you agree that NokNok will receive a fee per order equal to the percentage of the Price provided for in the MCO ("Fee"). For the purpose of these Terms, "Price" means the actual price paid by the Customer for the relevant order including any discounts (vouchers, credits, compensations or promotions) but excluding VAT, delivery fees, and any tips.</p>

    <p>You agree that, in the event the Customer uses electronic methods to settle the Price, you shall settle, in addition to the Fee, a payment gateway fee per order equal to the percentage of the total order value (including any tax, delivery or services fees) provided for in the MCO ("Gateway Fee").</p>

    <p>The Application will issue statements of account periodically as agreed upon in the MCO ("SOA") which you can access using your merchant portal. The SOA will show, in Lebanese Pounds and its equivalent United States of America Dollars calculated using the market rate adopted at the date of the SOA, and for the preceding relevant period (i) the Price of each order you received from the Application during the relevant preceding period; (ii) the total thereof ("Periodic Sales"); (iii) the Fees due to NokNok in accordance with this Section 5 and the Gateway Fees (The Fees and Gateway Fees together, the "Dues"; iv) the compensations and refunds disbursed to customers on behalf of the merchant and (v) the amount that NokNok should pay you which is equal to the Periodic Sales less the Dues ("Entitlement").</p>

    <p>Based on the SOA, which the Parties acknowledge as the sole valid reference for calculating the Entitlement, NokNok shall settle the Entitlement amount in Lebanese Pounds or its equivalent in United States Dollars, as reflected in the SOA, within two (2) business days. The Merchant shall then have three (3) business days from the date of settlement to review the payment and raise any reconciliation queries with NokNok's Accounts Payable team.</p>

    <p>For the purpose of this Section 5, you authorize NokNok, its employees, and service providers to collect the Price from the Customers on your behalf whether paid electronically or in cash.</p>

    <h2>6. Fees Discount</h2>
    <p>Subject to the provisions of this Section 6, you will be entitled to receive a cashback on the Fees due to NokNok, relative to your weekly sales performance and as specified in the Cashback table of the Merchant Commercial Offer (MCO).</p>

    <p>The Cashback is calculated on a weekly basis and is conditional upon the following cumulative conditions being met during the relevant week:</p>
    <ul>
      <li>You achieving the target number of sales provided for in the MCO during the relevant week; and</li>
      <li>No item or product is listed at a higher price than on your dine-in menu or than on any other comparable platform for food delivery services during that relevant week</li>
    </ul>

    <p>The SOA will show the Cashback (if any) and the invoice you issue in accordance with the provisions of Section 5 with respect to the Entitlement should account for the Cashback. For the avoidance of doubt, the settlement by NokNok of the amount figuring on the said invoice will release NokNok of its obligation towards you with respect to the Entitlement and Cashback (if any).</p>

    <p>Notwithstanding any other provision in these Terms particularly the provisions of Section 25, you agree that NokNok is entitled to unilaterally amend, at its sole and absolute discretion, the conditions of the Cashback provided for in this Section 6 and, in the event of such amendment, the conditions applicable to the Cashback will be such amended conditions provided to you by NokNok via email.</p>

    <h2>7. Intellectual Property</h2>
    <p>NokNok grants you a non-exclusive, non-transferable, revocable license during the duration of these Terms to access and use the Application solely for the purposes set out in these Terms.</p>

    <p>All rights, title and interest in and to the Application, any software NokNok provides for your use and any other material it provides to you under or in connection with these Terms are and will remain at all times NokNok's intellectual property.</p>

    <p>You must not and will not permit any third party to copy, adapt, reverse engineer, decompile, modify, or make error connections to any of NokNok's intellectual property other than with NokNok's express written consent. You must not and will not permit any third party to breach, disable, tamper with, or develop or use any workaround for any security measure in any NokNok intellectual properties or otherwise do anything that disrupt any of NokNok's intellectual property rights.</p>

    <p>Neither party to these Terms acquires any ownership rights in the other party's intellectual property through these Terms or the MIF.</p>

    <h2>8. Marketing and Promotion</h2>
    <p>For the purpose of this Section 8, "IP" means name, trademarks, service marks, tradenames, logos, and any branding materials (slogans and other identifying symbols).</p>

    <p>NokNok may include you in general marketing campaigns and promotional materials for the Application, feature your IP in promotional offers, discounts, or special campaigns; and in advertising materials across various media channels. For this purpose, exclusively, you grant NokNok a non-exclusive, royalty-free license to use, display, and reproduce your IP. You acknowledge and agree that your participation in such campaigns does not guarantee any minimum order volume or revenue.</p>

    <p>You undertake to place inside your physical stores advertising material related to NokNok and provided by the latter to promote the Application. For this purpose, exclusively, NokNok grants you a non-exclusive, non-transferable, royalty-free, revocable license during the duration of these Terms to display NokNok's IP in accordance with these Terms and the NokNok's brand guidelines as may be provided from time to time.</p>

    <p>Any promotional and marketing campaigns containing the other party's IP shall be subject to the party's prior written consent.</p>

    <p>Any goodwill derived from the use by the other party's IP under this Terms shall accrue to the said other party.</p>

    <p>Neither party to these Terms shall make any representations and warranties on behalf of the other party or use any marketing materials that may damage the other party's reputation or brand image.</p>

    <p>Neither party to these Terms shall carry out marketing campaigns or use promotional material that infringes the intellectual property rights of any third party.</p>

    <h2>9. Relationship of the Parties</h2>
    <p>Nothing in these Terms shall be deemed to constitute a partnership between the parties and no party shall act as an agent, associate, legal representative, or employee for the other party.</p>

    <p>The parties to these Terms shall not be, or purport to be, authorized to legally represent each other. The parties shall not have the authority to make any commitments or agreements or incur any liabilities whatsoever on behalf of each other or register these Terms under local registered agency law.</p>

    <h2>10. Data Protection and Privacy</h2>
    <p>You shall comply with all applicable data protection laws and regulations, including but not limited to the Law No. 81/2018 relating to Electronic Transactions and Personal Data and any other relevant privacy legislation.</p>

    <p>You acknowledge that NokNok may share with you Customers' personal data for the purpose of answering any complaints NokNok may receive from such Customers. You also acknowledge that such personal data may include names, delivery addresses, and order preferences, and NokNok acts as a data controller for Customer data collected through the Application. You shall only use such Customer personal data for the purpose of providing customer service, and you must not disclose Customer personal data to any third party without NokNok's prior written consent. You must implement appropriate technical and organizational measures to protect Customer personal data from unauthorized access, disclosure, alteration, or destruction and notify NokNok immediately upon becoming aware of any data breach or suspected breach involving Customer personal data.</p>

    <p>You shall retain Customer personal data only for as long as necessary to carry out customer service and comply with legal obligations and shall securely delete or return such data to NokNok upon termination of these Terms.</p>

    <p>Each party shall maintain adequate records of its data processing activities and shall cooperate with any Customer rights requests exercised in accordance with NokNok's privacy policy present on NokNok's website and Application and which you hereby acknowledge having read and accepted.</p>

    <h2>11. Confidentiality</h2>
    <p>Each party to these Terms shall (and shall procure that each other member of its group and their respective officers, employees, agents and advisers shall) in all respects keep confidential and not at any time disclose or make known in any way to any person or use for its own or any other person's benefit or to the detriment of the other party any Confidential Information, provided that:</p>

    <ul>
      <li>(a) such obligation shall not apply to information which becomes publicly available (other than through a breach of this Section 11);</li>
      <li>(b) a party shall be entitled at all times to disclose such information as may be required by law or by any competent judicial or regulatory authority, provided that, so far as practicable and legally permissible, the disclosing party shall consult with the other party prior to making any such disclosure under this Section 11;</li>
      <li>(c) a party shall be entitled at all times to disclose such information as may be required to enforce its rights under these Terms or for the purpose of any judicial or arbitral proceedings; and</li>
      <li>(d) a party shall be entitled to disclose to its officers, employees, agents or advisers such information as may be necessary to enable them to carry out their duties conditional upon any such person being informed of the confidential nature of such information and agreeing to keep such information confidential and each party acknowledges that it shall be liable for any failure by such persons to keep such information confidential.</li>
    </ul>

    <p>For the purpose of this Section 11, "Confidential Information" means, with respect to each party, all information (whether oral or recorded in any medium) relating to their business, governance, ownership structure and capitalization, and all information which is treated as confidential by the respective party or is by its nature confidential or which is not in the public domain including the content of the MCO, MIF and BIF and the other agreements and/or documents referred to in these Terms.</p>

    <p>The confidentiality obligation as provided for in this Section 11 shall be binding and remain in full force and effect for a period of 5 years following the termination of these Terms.</p>

    <h2>12. Representations and Warranties</h2>
    <p>Each party to these Terms represents and warrants to the other that it (i) is duly organized, validly existing and in good standing under the laws of its jurisdiction of incorporation; and (ii) has the full power and authority to enter into these Terms and to carry out its obligations hereunder.</p>

    <p>NokNok makes no representation or warranty, whether express or implied with respect to the success or profitability of your store on the Application, or that you will achieve any specific sales level via Application.</p>

    <h2>13. Liabilities</h2>
    <p>You acknowledge and agree that you, solely, will be liable to compensate the Customer, including but not limited to reimbursing the full payment made by the latter with respect to the relevant order, for any claim made by such Customer resulting from your act, omission, or negligence including but not limited to:</p>

    <ul>
      <li>(a) Your closure or unresponsiveness during your working hours;</li>
      <li>(b) Confirming an order whereas an ordered item is unavailable;</li>
      <li>(c) Delays resulting from your tardiness in preparing the order and/or handing it over to the driver;</li>
      <li>(d) Order items missing or items other than those ordered were delivered; or</li>
      <li>(e) Items delivered being unfit for consumption (e.g., undercooked or burnt food).</li>
    </ul>

    <p>You also acknowledge and agree that you will bear the cost of delivery for any case that requires Noknok to send another driver to re-deliver and/or complete an order.</p>

    <h2>14. Hold Harmless</h2>
    <p>You acknowledge and agree that you, solely, are liable for the compliance of your products and items to the applicable laws and regulations and for any harm caused by the consumption or use of your products, and that NokNok will bear no liability or responsibility whatsoever in this respect.</p>

    <p>You shall indemnify and hold NokNok harmless against all liabilities, damages, losses, fines, expenses and costs (including all interest, penalties, legal costs (calculated on a full indemnity basis) and reasonable professional costs and expenses) suffered or incurred by NokNok as a result of or in connection with any claim by a third party arising out of or in connection with these Terms, to the extent that the claim arises out of your breach, negligent performance or failure or delay in performance and for death, personal injury or damage to property arising out of or in connection with your products.</p>

    <p>You agree that NokNok shall not be liable under any circumstance whatsoever for any claim, damage, loss, or any third-party responsibility whether direct or indirect, consequential or otherwise arising out of these Terms and whether based in contract, tort, or otherwise.</p>

    <h2>15. Term</h2>
    <p>These Terms will enter into effect between the parties hereto as of the date of the signature of the Terms and will remain in effect for an indefinite period unless terminated in accordance with the provisions of Section 16.</p>

    <h2>16. Termination of the Terms</h2>
    <p>Either party to these Terms may terminate them at any time without cause by giving the other party 15 (fifteen) days prior to written notice. Upon expiry of the 15 (fifteen) days prior to written notice, these Terms will automatically terminate without the need for any other notice or legal recourse without any responsibility on either party.</p>

    <p>In the event either party to these Terms breaches any provision thereof, and does not remedy such breach within a period of 15 (fifteen) days as of the date it receives a written notice in this respect from the non-breaching party, the latter shall be entitled to automatically terminate these Terms at the full responsibility of the breaching party and without the need for any other notice or legal recourse.</p>

    <p>On the date on which the termination becomes effective (the sixteenth day), before the start of your working hours, your store will be removed from the Application.</p>

    <p>These Terms will automatically terminate without the need for any notice or legal recourse in the event either party becomes insolvent, makes any assignment for the benefit of creditors, goes to liquidation or has a receiver or trustee appointed for the benefit of creditors, whether voluntary or otherwise, or seeks the protection of, or has a proceeding instituted against it, under the bankruptcy code or any similar statute.</p>

    <p>Sections 10, 11, 12, 13, 14, and 18 shall survive the termination of these Terms.</p>

    <p>The termination of these Terms will be without prejudice to any rights and obligations accrued prior to or as a result of such termination and shall not relieve any party from liability for any breach of these Terms or from obligations expressly stated to survive termination.</p>

    <h2>17. Removal of the Store from the Application</h2>
    <p>You acknowledge and agree that, without prejudice to the provisions of Section 16 and other remedies available to NokNok in accordance with these Terms or by law, NokNok may, at its sole discretion, temporarily suspend your use of the Application immediately by giving you notice via email in this respect if NokNok suspects that you have breached these Terms, or if NokNok otherwise considers suspension reasonably necessary taking into account all relevant circumstances. NokNok will give the reasons for the suspension and will maintain the suspension until you have remedied the breach to NokNok's satisfaction or NokNok no longer considers the suspension necessary in the circumstances.</p>

    <h2>18. Governing Law and Jurisdiction</h2>
    <p>These Terms, and any dispute or claim (including non-contractual disputes or claims) arising out of or in connection with it or its subject matter or formation, shall be governed by and construed in accordance with the law of the Republic of Lebanon.</p>

    <p>Each party irrevocably agrees that the courts of Beirut shall have exclusive jurisdiction to settle any dispute or claim (including non-contractual disputes or claims) arising out of or in connection with these Terms or its subject matter or formation.</p>

    <h2>19. Regulatory</h2>
    <p>Each party undertakes that it shall at all times abide by (i) applicable anti-money laundering and anti-corruption laws, rules and regulations issued or applied by; and (ii) economic or financial sanctions administered by the United Nations, the Organization for Economic Co-operation and Development (OECD), the United States of America, the European Union, and the World Bank.</p>

    <h2>20. Non-Assignment</h2>
    <p>You shall not, nor shall you purport to assign, transfer, charge or otherwise deal with all or any of your rights and/or obligations under these Terms nor grant, declare, create or dispose of any right or interest in it in whole or in part without the prior written consent of NokNok.</p>

    <p>NokNok shall be entitled to assign, transfer, charge or otherwise deal with all or any of its rights and/or obligations under these without your prior consent to its affiliates.</p>

    <h2>21. Severance</h2>
    <p>If any provision or part-provision of these Terms is or becomes invalid, illegal or unenforceable, it shall be deemed deleted, but that shall not affect the validity and enforceability of the rest of the Terms.</p>

    <h2>22. Waiver</h2>
    <p>No waiver of any provision or performance or condition of these Terms shall be effective unless it is in writing and signed by or on behalf of the party waiving compliance.</p>

    <p>A failure or delay by a party to exercise any right or remedy provided under the Terms or by law shall not constitute a waiver of that or any other right or remedy, nor shall it prevent or restrict any further exercise of that or any other right or remedy. No single or partial exercise of any right or remedy provided under these Terms or by law shall prevent or restrict the further exercise of that or any other right or remedy.</p>

    <h2>23. Notices</h2>
    <p>Any notice or other formal communication to be given under these Terms shall be in writing and signed by or on behalf of the party giving it. It shall be delivered by hand or sent by prepaid recorded delivery, special delivery or registered post to the address shown for this purpose in the MIF beside "Entity Address".</p>

    <h2>24. Entire Agreement</h2>
    <p>These Terms together with the MCO, MIF and BIF are the entire agreement between us in relation to your use of the Application. You acknowledge that you have not relied on any statement, promise, representation, assurance, or warranty made or given on behalf of NokNok which is not set out in these Terms.</p>

    <h2>25. Variation</h2>
    <p>Any variation to these Terms is valid only if it is in writing and communicated by NokNok on the following link: (https://www.noknok-lebanon.co).</p>

  </section>
</main>

<!-- Footer -->
<footer class="site-footer">
  <div class="footer-inner">

    <!-- Column 1 -->
    <div class="footer-brand">
      <div class="footer-logo">
        <img src="assets/images/terms-and-conditions/logo2.png" alt="NokNok Logo" />

      </div>


      <div class="store-icons">
        <a href="https://apps.apple.com/lb/app/noknok-one-touch/id1360852720" aria-label="App Store" target="_blank"><img src="assets/images/terms-and-conditions/appstore.svg"></a>
        <a href="https://play.google.com/store/apps/details?id=co.noknok&hl=en" aria-label="Google Play" target="_blank"><img src="assets/images/terms-and-conditions/googleplay.svg"></a>
      </div>
    </div>

    <!-- Column 2 -->
    <div class="footer-col">

      <ul class="footer-links">
        <li><b>Lebanon</b></li>
        <li>info@noknok-lebanon.co</li>
        <li>+961 4 541 441</li>
        <li>Dbayeh Highway, Spinneys HQ Tower, Bloc A, 4th floor P.O. Box: 90-1532 Jeidet el Metn, Lebanon.</li>
      </ul>
    </div>

    <!-- Column 3 -->
    <div class="footer-col">

      <ul class="footer-links">
        <li><b>Ghana</b></li>
        <li>info@noknok-ghana.co</li>
        <li>+233 597 400001</li>
        <li>6 Ako Adjei, Osu, Accra. Ghana</li>
      </ul>
    </div>

    <!-- Column 4 -->
    <div class="footer-col">
      <h3>Stay Connected</h3>
      <div class="social">
        <a href="https://www.facebook.com/noknokgroceries" target="_blank" aria-label="Facebook">f</a>
        <a href="https://www.instagram.com/noknokgrocerieslebanon?igsh=NWk5eHh5dmp1ZWFq&utm_source=qr"  target="_blank"  aria-label="Instagram">ig</a>
        <a href="https://www.linkedin.com/company/noknok-app/"  target="_blank"  aria-label="LinkedIn">in</a>
        <a href="https://twitter.com/noknokgroceries"  target="_blank"  aria-label="X">x</a>
      </div>
    </div>

  </div>

  <div class="footer-bottom">
    © 2026 NokNok. All rights reserved.
  </div>
</footer>

</body>
</html>
